import React from 'react';
import './ChipRole.css'; // Archivo CSS para estilos
import { IUser } from '@/redux/models';

const ChipRole = ({ label }: { label: IUser['role'] }) => {

    return (
        <div className={`chip ${label}`}>
            <span className="chip-label">{label}</span>
        </div>
    );
};

export default ChipRole;
